import { defaultState } from './state';
import { urls } from '@/utils';
import get from 'lodash/get';

export default {
	autogenerateEddCreds({ dispatch }) {
		return dispatch('saveEddCreds', { auto: true });
	},

	async saveEddCreds({ commit }, { publicKey, token, auto = false }) {
		commit('loading', 'eddconnect', { root: true });

		try {
			const { body } = await this._vm.$api
				.post({ wpEndpoint: `omapp/v1/edd/${auto ? 'autogenerate' : 'save'}` })
				.send({ publicKey, token });

			commit('doneLoading', 'eddconnect', { root: true });

			commit('fetched', 'eddSettings', { root: true });
			commit('setEddConnected', Boolean(body.isEddConnected));
			commit('setEddKey', body.key);
			commit('setEddToken', body.token);

			this._vm.$bus.$emit('eddKeyFetched', body);
		} catch (error) {
			commit('closeAlerts', null, { root: true });

			commit('setEddConnected', false);
			error.explanation = `<strong>Something went wrong while attempting to ${
				auto ? 'autogenerate' : 'save'
			} the EDD Keys.</strong>`;

			const errorMessage = get(error, 'response.body.message', '');

			if (errorMessage.toLowerCase().includes('edd api not properly configured')) {
				const permalinkUrl = urls.wp('wp-admin/options-permalink.php');
				error.explanation += `<p>If you see this error multiple times, try <a href="${permalinkUrl}" target="_blank">re-saving your permalinks</a>.</p>`;
			}

			error.closes = true;
			commit('setError', error, { root: true });
			commit('doneLoading', 'eddconnect', { root: true });

			// eslint-disable-next-line no-console
			console.error({ error });

			throw error;
		}
	},

	async disconnectEdd({ commit }) {
		commit('loading', 'eddconnect', { root: true });
		try {
			await this._vm.$api.post({ wpEndpoint: 'omapp/v1/edd/disconnect' });

			const { eddKey, eddToken } = defaultState();

			commit('setEddConnected', false);
			commit('setEddKey', eddKey);
			commit('setEddToken', eddToken);
			commit('doneLoading', 'eddconnect', { root: true });
			this._vm.$bus.$emit('eddKeyRemoved');
		} catch (error) {
			commit('closeAlerts', null, { root: true });

			error.explanation = '<strong>Something went wrong while attempting to disconnect EDD.</strong>';
			error.closes = true;
			commit('setError', error, { root: true });
			commit('doneLoading', 'eddconnect', { root: true });
			// eslint-disable-next-line no-console
			console.error({ error });
			throw error;
		}
	},

	async fetchEddSettings({ getters, commit, rootGetters }) {
		if (!getters.isEddActive) {
			return;
		}

		if (rootGetters.isFetched('eddSettings') || rootGetters.isFetching('eddSettings')) {
			return;
		}

		commit('fetching', 'eddSettings', { root: true });

		try {
			const { body } = await this._vm.$api.get({ wpEndpoint: 'omapp/v1/edd/settings' });

			commit('fetched', 'eddSettings', { root: true });
			commit('setEddConnected', Boolean(body.isEddConnected));
			commit('setEddKey', body.key);
			commit('setEddToken', body.token);
			commit('setEddVersion', {
				isMinimum: body.isEddMinimumVersion,
				current: body.currentVersion,
				minimum: body.minimumVersion,
			});

			this._vm.$bus.$emit('eddKeyFetched', body);
		} catch (error) {
			error.explanation = '<strong>Something went wrong while attempting to fetch EDD settings.</strong>';
			// eslint-disable-next-line no-console
			console.error({ error });
			throw error;
		}
	},
};
